import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import Table, { Table$SortEvent } from "sap/ui/table/Table";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ListHandler from "vamos/cockpit/base/handler/ListHandler";
import V4Context from "sap/ui/model/odata/v4/Context";
import Button, { Button$PressEvent } from "sap/m/Button";
import Dialog, { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import ValidationUtil from "vamos/cockpit/base/util/ValidationUtil";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import MessageBox from "sap/m/MessageBox";

type Arguments = {
  "?query": {
    SupplierGuid: string,
  };
}
/**
 * @namespace vamos.cockpit.data.supplier.controller
 */
export default class GoodsRecipientEditController extends BaseTypeController {
  protected readonly _sEmptyHistoryRoute: string = "supplier";
  private supplierGuid?: string = null;
  private listHandler: ListHandler;

  onInit() {
    super.onInit();

    this.listHandler = new ListHandler(this.getTable(), this.viewModel);
  }

  public onRoutePatternMatched(e: Route$PatternMatchedEvent) {
    super.onRoutePatternMatched(e);

    // todo leere query abfangen
    const args = e.getParameter("arguments") as Arguments;
    this.supplierGuid = args["?query"].SupplierGuid;

    const filter: Filter = new Filter("SupplierGuid", FilterOperator.EQ, this.supplierGuid);
    this.listHandler.bindTable("GoodsRecipient", { $$updateGroupId: "$direct" }, [filter]);
  }

  private getTable(): Table {
    return this.byId("table") as Table;
  }

  private refreshTable() {
    const listbinding: ODataListBinding = this.getTable().getBinding("rows") as ODataListBinding;
    return listbinding.requestRefresh();
  }

  public async onSetDefault() {
    const selectedContext = this.listHandler.getSelectedContext()[0] as V4Context;
    await selectedContext.setProperty("IsDefaultRecipient", true);
    await this.refreshTable();
  }

  public async onDelete() {
    const selectedContext = this.listHandler.getSelectedContext()[0] as V4Context;
    const object:any = selectedContext.getObject();
    const message:string = object.IsDefaultRecipient ? this.getText("DeleteDefaultGoodsRecipientText") : this.getText("DeleteEntryText");
    MessageBox.show(message, {
      icon:  MessageBox.Icon.WARNING,
      title: this.getText("Delete"),
      actions: [MessageBox.Action.OK, MessageBox.Action.CANCEL],
      onClose: async (oAction) => {
        if (oAction === MessageBox.Action.OK) {
          await selectedContext.delete();
          await this.refreshTable();
        }
      },
    });
  }

  public async onAdd(event: Button$PressEvent) {
    const button: Button = event.getSource();
    const dialog: Dialog = this.findParentControl("sap.m.Dialog", button) as Dialog;

    if (ValidationUtil.hasEmptyRequiredFields(dialog)) {
      return;
    }

    await this.saveGoodsRecipient(dialog);
    await this.refreshTable();
    this.onClosePopup(event);

  }

  public async onAddAndNew(event: Button$PressEvent) {
    const button: Button = event.getSource();
    const dialog: Dialog = this.findParentControl("sap.m.Dialog", button) as Dialog;

    if (ValidationUtil.hasEmptyRequiredFields(dialog)) {
      return;
    }

    await this.saveGoodsRecipient(dialog);
    await this.refreshTable();

    const context: V4Context = this.bindContext();
    dialog.setBindingContext(context);
  }
  public onCloseGoodsRecipientPopup(event: Button$PressEvent) {
    this.onClosePopup(event);
  }
  public afterGoodsRecipientDialogClosed(event: Dialog$AfterCloseEvent){
    (this.getModel() as ODataModel).resetChanges("create");

  }

  public async saveGoodsRecipient(dialog: Dialog) {

    const context: V4Context = dialog.getBindingContext() as V4Context;
    try {
      await this.submitBatch(context.getUpdateGroupId());
    } catch (e) {
      console.error(e);
    }
    if (context.hasPendingChanges()) {
      throw new Error("batch failed");
    }
  }

  public bindContext(): V4Context {
    const context = this.createModelEntry("GoodsRecipient", {}, null, "create") as V4Context;
    context.setProperty("SupplierGuid", this.supplierGuid).catch((e) => {
      console.error(e);
    });
    return context;
  }


  public onSort(event: Table$SortEvent) {
    this.listHandler.onSort(event);
  }
}